import React from 'react'

function createMarkup(props) {
  return {__html: (props.html)};
}

function MyComponent(props) {
  return <div dangerouslySetInnerHTML={createMarkup(props)} />;
}

const HtmlBox = ({fieldClass, text}) => (
  <div className="form-group col-md-12 mb-0">
      <div className={fieldClass}>
          <MyComponent html={text} />
      </div>
  </div>
);

export default HtmlBox